import React, { FC } from "react";
import { useField } from "formik";
import { IFormField } from "src/@types/form";
import { FormField } from ".";
import { SingleCheckboxSelector } from "../CheckboxSelector/SingleCheckboxSelector";

export const SingleCheckboxSelectorField: FC<IFormField> = ({
  options,
  fieldClassName,
  labelClassName,
  id,
  label,
  name,
}) => {
  const fieldId = id || name;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fieldProps, _, fieldHelpers] = useField<string>(fieldId);

  const { value } = fieldProps;
  const { setValue } = fieldHelpers;

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      label={label}
      labelFor={fieldId}
    >
      <SingleCheckboxSelector
        options={options}
        activeValue={value}
        setActiveValue={setValue}
      />
    </FormField>
  );
};
